import store from "../../redux/store";
import { logoutCallback } from "./helpers";
import * as helpers from "./helpers";
function parseJSON(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 500) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export default function request(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON);
}

export function createQueryString(queryParams) {
  const keyValuePairs = [];

  for (const key in queryParams) {
    keyValuePairs.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])
    );
  }
  return keyValuePairs.join("&");
}

export function createHeadersWithAuth() {
  // const {
  //   auth: { authToken },
  // } = store.getState();
  const authToken = helpers.getAuthToken(); 
  return {
    jwtAuthorization: authToken,
    Authorization: "Bearer " + authToken,
  };
}

export function createHeaders() {
  return {
    "Content-Type": "application/json",
  };
} 

export async function requestPromise(url, options) {
  try {
    const { dispatch } = store;
    const response = await fetch(url, {...options, credentials: 'include'})
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        if(response.status == 401 && response.error.message == 'Invalid token') { 
          logoutCallback(true);
          return response;
        }
        return response;
      });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function requestPromiseObj(url, options) {
  return new Promise((resolve, reject) => {
    fetch(url, { ...options, credentials: 'include' })
      .then((resp) => {
        if (resp.ok || resp.status === 200) {
          return resp.json();
        } else {
          return resp.json()
          .then(err => {
            throw new Error(err || 'Failde to change the password');
          })
          .catch((err) => {
            throw new Error(err || 'Failed to parse error response');
          })
        }
      })
      .then((resp) => {
        resolve({ status: 'success', message: resp });
      })
      .catch((err) => {
        reject({
          status: 'error',
          message: err.message,
        });
      });
  });
}

